<template lang="pug">
Button.card(@click="onCardClicked")
  .card__head
    .card__head-wrapper
      img.card__head-wrapper-img(:src="info.image_url")
  .card__footer(v-if="renderBuyButton")
    .card__footer-buy {{ $t('single_words.buy') }}
  .card__price {{ `$${info.price}` }}
  .card__months {{ monthsTag }}
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true
    },
    renderBuyButton: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    monthsTag () {
      const tag = `${this.info.months} ${this.info.months === 1 ? this.$t('single_words.month') : this.$t('single_words.months')}`
      return tag.toLocaleLowerCase()
    }
  },
  methods: {
    onCardClicked () {
      this.$emit('click', this.info.price)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background-color: #ffffff;
  border: none;
  padding: 0;
  margin: 0;
  outline: none;
  cursor: pointer;
  overflow: hidden;
  border-radius: 0;
  &__head {
    position: relative;
    width: 343px;
    height: 260px;

    &-wrapper {
      width: 390px;
      height: 300px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      &-img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &__footer {
    position: relative;
    padding: 0 $gap $gap $gap;
    width: 100%;
    background-color: #ffffff;
    z-index: 1;
    &-buy {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 40px;
      border-radius: 4px;
      color: white;
      font-weight: 700;
      background: linear-gradient(135deg, #f87900, #fe4f45, #e419ba);
    }
  }

  &__price {
    position: absolute;
    top: 10px;
    right: 16px;
    width: 53px;
    height: 30px;
    background: linear-gradient(90deg, #f4a143, #e44b88, #7524aa 90%);
    color: #ffffff;
    border-radius: 100px;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__months {
    position: absolute;
    top: 86px;
    left: 30px;
    font-size: 18px;
    font-weight: 700;
    color: #1c0c32;
  }
}
</style>
